import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector) // Usamos el detector estándar, es más que suficiente.
  .use(initReactI18next)
  .init({
    supportedLngs: ['es', 'en', 'pt'],
    fallbackLng: 'es',
    // debug: import.meta.env.DEV,
    debug: false,

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    // --- CONFIGURACIÓN DE DETECCIÓN CORREGIDA ---
    detection: {
      // Orden de detección para un visitante nuevo:
      // 1. 'localStorage': ¿El usuario ya eligió un idioma en una visita anterior?
      // 2. 'navigator': Si no, usa el idioma de su navegador.
      // Tu lógica en App.jsx para usuarios logueados seguirá funcionando para refinar esto.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: true, // <-- ESTE ES EL CAMBIO CLAVE
    },
  });

export default i18n;
